import { reactive, ref, onMounted, onUnmounted, nextTick, watch } from '@vue/composition-api'

export const useTruncatedTooltip = (keys, watchSource) => {
  const elementRefs = {}
  const initialTruncated = {}

  keys.forEach((key) => {
    elementRefs[key] = ref(null)
    initialTruncated[key] = false
  })

  // All keys must exist on the object passed to `reactive()` up front —
  // Vue 2's reactivity can't track a property added afterward via assignment.
  const truncated = reactive(initialTruncated)

  const checkTruncation = () => {
    keys.forEach((key) => {
      const el = elementRefs[key].value

      truncated[key] = !!el && el.scrollWidth > el.clientWidth
    })
  }

  const scheduleCheck = () => nextTick(checkTruncation)

  let resizeObserver = null

  onMounted(() => {
    scheduleCheck()

    if ('undefined' !== typeof ResizeObserver) {
      resizeObserver = new ResizeObserver(scheduleCheck)

      keys.forEach((key) => {
        if (elementRefs[key].value) resizeObserver.observe(elementRefs[key].value)
      })
    } else {
      window.addEventListener('resize', scheduleCheck)
    }
  })

  onUnmounted(() => {
    if (resizeObserver) {
      resizeObserver.disconnect()
    } else {
      window.removeEventListener('resize', scheduleCheck)
    }
  })

  if (watchSource) {
    watch(watchSource, scheduleCheck, { deep: true })
  }

  return {
    truncated,
    ...elementRefs
  }
}
